import clsx from 'clsx';
import type { ReactNode } from 'react';

import BaseContainer from '@commons/containers/BaseContainer';
import type { Theme } from '@commons/types/styles';

import styles from './MobilePane.module.scss';

// Type definition of the MobileMenuPane component properties.

type Props = {
  as?: 'div' | 'nav';
  theme: Theme;
  visible: boolean;
  trigger: ReactNode;
  children: ReactNode;
  subPane?: boolean;
  className?: string;
};

/**
 * Mobile menu pane component.
 *
 * Renders a controlled mobile menu pane with a trigger button.
 */

const MobileMenuPane = ({ as = 'div', visible, trigger, children, theme, className }: Props) => {
  const classes = clsx(
    styles.pane,
    visible && styles.visible,
    visible && 'activeMobileMenu',
    className
  );

  return (
    <>
      {trigger}
      <BaseContainer as={as} theme={theme} className={classes}>
        {children}
      </BaseContainer>
    </>
  );
};

export default MobileMenuPane;
